export const UPDATE_FEATURE_START = 'UPDATE_FEATURE_START';
export const UPDATE_FEATURE_SUCCESS = 'UPDATE_FEATURE_SUCCESS';
export const UPDATE_FEATURE_ERROR = 'UPDATE_FEATURE_ERROR';
